module.exports = __webpack_public_path__ + "static/media/NavbarBrand.f9b14c1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/NavbarBrand.png
// module id = 204
// module chunks = 15